angular
    .module('dnecom')
    .directive('dynamicFormControl', ["$parse", function($parse) {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function(scope, element, attrs, ngModel) {
                var parentFormGroup = element.parents('.form-group').first();

                var getValue = function () {
                    if(ngModel) {
                        return ngModel.$viewValue;
                    }

                    return $parse(attrs.dynamicFormControl)(scope);
                };

                /*
                 * Alter the form-group state if the element is not being focused.
                 */
                scope.$watch(function(){
                    return getValue();
                }, function(value) {
                    if (element.data('focus')) {
                        return;
                    }

                    parentFormGroup.toggleClass('form-group-active', !!value);
                });

                /*
                 * Mark the focus state as data property
                 * and alter the form-group state if there's no value.
                 */
                var handleFocus = function(value) {
                    element.data('focus', value);

                    if (getValue()) {
                        return;
                    }

                    parentFormGroup.toggleClass('form-group-active', value);
                };

                // Listen to element focus changes

                if (typeof attrs.dynamicFormControlFocus != 'undefined') {
                    scope.$watch(function() {
                        return $parse(attrs.dynamicFormControlFocus)(scope);
                    }, handleFocus);
                }

                if (typeof attrs.dynamicFormControlIgnoreRoot === 'undefined'
                        || !$parse(attrs.dynamicFormControlIgnoreRoot)(scope)) {
                    element.on('focus', function () {
                        handleFocus(true);
                    });

                    element.on('focusout', function () {
                        handleFocus(false);
                    });
                }
            }
        };
    }]);
